export default "__VITE_ASSET__BmmpQFiY__"